import { type CdbUserContextDto, type CdbUserContextPartnerInfoDto } from '../models'

export type IHubAuthState = {
  _currentUser: CdbUserContextDto | null
  _currentPartner: CdbUserContextPartnerInfoDto | null
}

export const INITIAL_STATE: IHubAuthState = {
  _currentUser: null,
  _currentPartner: null
}
